import { BaseService } from "services/_baseService";

class WagonsAdminService extends BaseService<any> {
  constructor() {
    super(`wagons`);
  }
}

export default new WagonsAdminService();
